export default __webpack_public_path__ + "static/media/arrowDetails.b3898bf3.svg";